import React, { useState, useEffect } from 'react';
import { useAuth } from '../AuthContext';

function AdminPaymentsPage() {
  const [settings, setSettings] = useState({
    crystalpay_api_key: '',
    crystalpay_api_secret: '',
    heleket_api_key: '',
    telegram_bot_token: '',
    yookassa_shop_id: '',
    yookassa_secret_key: '',
    yookassa_receipt_required: false,
    yoomoney_receiver: '',
    yoomoney_notification_secret: '',
    platega_api_key: '',
    platega_merchant_id: '',
    platega_mir_enabled: false,
    mulenpay_api_key: '',
    mulenpay_secret_key: '',
    mulenpay_shop_id: '',
    urlpay_api_key: '',
    urlpay_secret_key: '',
    urlpay_shop_id: '',
    monobank_token: '',
    btcpayserver_url: '',
    btcpayserver_api_key: '',
    btcpayserver_store_id: '',
    tribute_api_key: '',
    robokassa_merchant_login: '',
    robokassa_password1: '',
    robokassa_password2: ''
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [saveStatus, setSaveStatus] = useState(null); // 'saving', 'success', 'error'
  const { token } = useAuth();
  
  // --- 1. Загрузка текущих ключей ---
  useEffect(() => {
    const fetchSettings = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await fetch('/api/admin/payment-settings', {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        if (!response.ok) throw new Error('Не удалось загрузить настройки');
        const data = await response.json();
        // ❗️ API вернет "DECRYPTION_ERROR" если ключи пустые,
        // ❗️ мы заменим это на пустую строку для формы
        if (data.crystalpay_api_key === "DECRYPTION_ERROR") data.crystalpay_api_key = "";
        if (data.crystalpay_api_secret === "DECRYPTION_ERROR") data.crystalpay_api_secret = "";
        if (data.heleket_api_key === "DECRYPTION_ERROR") data.heleket_api_key = "";
        if (data.telegram_bot_token === "DECRYPTION_ERROR") data.telegram_bot_token = "";
        if (data.yookassa_shop_id === "DECRYPTION_ERROR") data.yookassa_shop_id = "";
        if (data.yookassa_secret_key === "DECRYPTION_ERROR") data.yookassa_secret_key = "";
        if (data.yoomoney_receiver === "DECRYPTION_ERROR") data.yoomoney_receiver = "";
        if (data.yoomoney_notification_secret === "DECRYPTION_ERROR") data.yoomoney_notification_secret = "";
        if (data.platega_api_key === "DECRYPTION_ERROR") data.platega_api_key = "";
        if (data.platega_merchant_id === "DECRYPTION_ERROR") data.platega_merchant_id = "";
        if (data.mulenpay_api_key === "DECRYPTION_ERROR") data.mulenpay_api_key = "";
        if (data.mulenpay_secret_key === "DECRYPTION_ERROR") data.mulenpay_secret_key = "";
        if (data.mulenpay_shop_id === "DECRYPTION_ERROR") data.mulenpay_shop_id = "";
        if (data.urlpay_api_key === "DECRYPTION_ERROR") data.urlpay_api_key = "";
        if (data.urlpay_secret_key === "DECRYPTION_ERROR") data.urlpay_secret_key = "";
        if (data.urlpay_shop_id === "DECRYPTION_ERROR") data.urlpay_shop_id = "";
        if (data.monobank_token === "DECRYPTION_ERROR") data.monobank_token = "";
        if (data.btcpayserver_url === "DECRYPTION_ERROR") data.btcpayserver_url = "";
        if (data.btcpayserver_api_key === "DECRYPTION_ERROR") data.btcpayserver_api_key = "";
        if (data.btcpayserver_store_id === "DECRYPTION_ERROR") data.btcpayserver_store_id = "";
        if (data.tribute_api_key === "DECRYPTION_ERROR") data.tribute_api_key = "";
        if (data.robokassa_merchant_login === "DECRYPTION_ERROR") data.robokassa_merchant_login = "";
        if (data.robokassa_password1 === "DECRYPTION_ERROR") data.robokassa_password1 = "";
        if (data.robokassa_password2 === "DECRYPTION_ERROR") data.robokassa_password2 = "";
        if (data.freekassa_shop_id === "DECRYPTION_ERROR") data.freekassa_shop_id = "";
        if (data.freekassa_secret === "DECRYPTION_ERROR") data.freekassa_secret = "";
        if (data.freekassa_secret2 === "DECRYPTION_ERROR") data.freekassa_secret2 = "";
        setSettings(data);
      } catch (e) { 
        setError(e.message); 
      } finally { 
        setLoading(false); 
      }
    };
    
    if (token) {
      fetchSettings();
    }
  }, [token]);

  // --- 2. Обработчик изменения полей ---
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setSettings(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  // --- 3. Сохранение настроек ---
  const handleSave = async (e) => {
    e.preventDefault();
    setSaveStatus('saving');
    setError(null);
    try {
      const response = await fetch('/api/admin/payment-settings', {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(settings)
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.message || 'Ошибка сохранения');
      
      setSaveStatus('success');
      setTimeout(() => setSaveStatus(null), 2000); // Показать "Сохранено!" на 2 сек

    } catch (e) {
      setError(e.message);
      setSaveStatus('error');
    }
  };
  
  if (loading) {
    return (
      <main className="admin-page-content">
        <section><div className="loading-mini">Загрузка...</div></section>
      </main>
    );
  }

  return (
    <main className="admin-page-content">
      <section>
        <h2>Настройки Платежных Систем</h2>
        <p className="admin-description-text">
          Ключи API шифруются на сервере и никогда не хранятся в открытом виде.
        </p>
        
        {error && <div className="message-error">{error}</div>}
        
        <form className="tariff-form" onSubmit={handleSave}>
          
          {/* --- CrystalPAY --- */}
          <h3>CrystalPAY</h3>
          <div className="form-row">
            <div className="form-group">
              <label>API Key (Cassa ID)</label>
              <input 
                type="text" 
                name="crystalpay_api_key"
                value={settings.crystalpay_api_key} 
                onChange={handleChange} 
                placeholder="Например, mykassa"
              />
            </div>
            <div className="form-group">
              <label>API Secret (Secret Key 1)</label>
              <input 
                type="text" 
                name="crystalpay_api_secret"
                value={settings.crystalpay_api_secret} 
                onChange={handleChange} 
                placeholder="Секретный ключ..."
              />
            </div>
          </div>
          
          {/* --- Heleket --- */}
          <h3 style={{marginTop: '30px'}}>Heleket</h3>
          <div className="form-row">
            <div className="form-group">
              <label>API Key</label>
              <input 
                type="text" 
                name="heleket_api_key"
                value={settings.heleket_api_key} 
                onChange={handleChange} 
                placeholder="API ключ Heleket..."
              />
            </div>
          </div>
          
          {/* --- Telegram Stars --- */}
          <h3 style={{marginTop: '30px'}}>Telegram Stars ⭐</h3>
          <div className="form-row">
            <div className="form-group">
              <label>Bot Token</label>
              <input 
                type="text" 
                name="telegram_bot_token"
                value={settings.telegram_bot_token} 
                onChange={handleChange} 
                placeholder="Bot Token от @BotFather..."
              />
            </div>
          </div>
          
          {/* --- Monobank --- */}
          <h3 style={{marginTop: '30px'}}>Monobank 💳</h3>
          <div className="form-row">
            <div className="form-group">
              <label>Token (X-Token)</label>
              <input 
                type="text" 
                name="monobank_token"
                value={settings.monobank_token} 
                onChange={handleChange} 
                placeholder="Токен из личного кабинета monobank.ua..."
              />
              <small style={{color: 'var(--text-secondary)', fontSize: '12px'}}>
                Токен можно получить в личном кабинете monobank.ua
              </small>
            </div>
          </div>
          
          {/* --- YooKassa --- */}
          <h3 style={{marginTop: '30px'}}>YooKassa</h3>
          <div className="form-row">
            <div className="form-group">
              <label>Shop ID (Идентификатор магазина)</label>
              <input 
                type="text" 
                name="yookassa_shop_id"
                value={settings.yookassa_shop_id} 
                onChange={handleChange} 
                placeholder="Идентификатор магазина из личного кабинета YooKassa"
              />
              <small style={{color: 'var(--text-secondary)', fontSize: '12px'}}>
                Идентификатор магазина можно найти в личном кабинете YooKassa
              </small>
            </div>
            <div className="form-group">
              <label>Secret Key (Секретный ключ)</label>
              <input 
                type="text" 
                name="yookassa_secret_key"
                value={settings.yookassa_secret_key} 
                onChange={handleChange} 
                placeholder="Секретный ключ из личного кабинета YooKassa"
              />
              <small style={{color: 'var(--text-secondary)', fontSize: '12px'}}>
                Секретный ключ для аутентификации запросов. YooKassa поддерживает только RUB.
              </small>
            </div>
          </div>
          <div className="form-row" style={{marginTop: '15px'}}>
            <div className="form-group">
              <label style={{display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer'}}>
                <input 
                  type="checkbox" 
                  name="yookassa_receipt_required"
                  checked={settings.yookassa_receipt_required || false} 
                  onChange={handleChange}
                  style={{width: 'auto', margin: 0}}
                />
                <span>Требовать receipt (чек) при создании платежа</span>
              </label>
              <small style={{color: 'var(--text-secondary)', fontSize: '12px', display: 'block', marginTop: '4px'}}>
                Включите, если в настройках магазина YooKassa включена обязательная отправка чеков в ФНС.
                Если выключено, receipt не будет отправляться (рекомендуется, если чеков не требуется).
              </small>
            </div>
          </div>
          <div style={{marginTop: '10px', padding: '10px', backgroundColor: 'var(--bg-secondary)', borderRadius: '4px'}}>
            <small style={{color: 'var(--text-secondary)', fontSize: '12px'}}>
              <strong>Важно:</strong> После настройки YooKassa необходимо указать URL вебхука в личном кабинете YooKassa: <br/>
              <code style={{wordBreak: 'break-all'}}>{typeof window !== 'undefined' ? window.location.origin : ''}/api/webhook/yookassa</code>
            </small>
          </div>

          {/* --- YooMoney --- */}
          <h3 style={{marginTop: '30px'}}>YooMoney</h3>
          <div className="form-row">
            <div className="form-group">
              <label>Receiver (номер кошелька)</label>
              <input
                type="text"
                name="yoomoney_receiver"
                value={settings.yoomoney_receiver}
                onChange={handleChange}
                placeholder="Например: 41001XXXXXXXXXX"
              />
              <small style={{color: 'var(--text-secondary)', fontSize: '12px'}}>
                Номер вашего кошелька YooMoney (receiver) для приёма платежей.
              </small>
            </div>
            <div className="form-group">
              <label>Notification Secret (секретное слово)</label>
              <input
                type="text"
                name="yoomoney_notification_secret"
                value={settings.yoomoney_notification_secret}
                onChange={handleChange}
                placeholder="Секретное слово для sha1_hash"
              />
              <small style={{color: 'var(--text-secondary)', fontSize: '12px'}}>
                Используется для проверки подписи уведомлений YooMoney (sha1_hash). Без него платежи не будут подтверждаться.
              </small>
            </div>
          </div>
          <div style={{marginTop: '10px', padding: '10px', backgroundColor: 'var(--bg-secondary)', borderRadius: '4px'}}>
            <small style={{color: 'var(--text-secondary)', fontSize: '12px'}}>
              <strong>Важно:</strong> Для YooMoney нужно включить HTTP-уведомления и указать URL: <br/>
              <code style={{wordBreak: 'break-all'}}>{typeof window !== 'undefined' ? window.location.origin : ''}/api/webhook/yoomoney</code>
            </small>
          </div>
          
          {/* --- Platega --- */}
          <h3 style={{marginTop: '30px'}}>Platega</h3>
          <div className="form-row">
            <div className="form-group">
              <label>API Key</label>
              <input 
                type="text" 
                name="platega_api_key"
                value={settings.platega_api_key} 
                onChange={handleChange} 
                placeholder="API ключ из личного кабинета Platega"
              />
              <small style={{color: 'var(--text-secondary)', fontSize: '12px'}}>
                API ключ для аутентификации запросов к Platega API
              </small>
            </div>
            <div className="form-group">
              <label>Merchant ID (UUID)</label>
              <input 
                type="text" 
                name="platega_merchant_id"
                value={settings.platega_merchant_id} 
                onChange={handleChange} 
                placeholder="UUID мерчанта из личного кабинета Platega"
              />
              <small style={{color: 'var(--text-secondary)', fontSize: '12px'}}>
                Идентификатор мерчанта (UUID) можно найти в личном кабинете Platega
              </small>
            </div>
          </div>
          <div className="form-row" style={{marginTop: '10px'}}>
            <div className="form-group">
              <label style={{display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer'}}>
                <input
                  type="checkbox"
                  name="platega_mir_enabled"
                  checked={settings.platega_mir_enabled || false}
                  onChange={handleChange}
                  style={{width: 'auto', margin: 0}}
                />
                <span>Включить “Карты МИР” (paymentMethod=11)</span>
              </label>
              <small style={{color: 'var(--text-secondary)', fontSize: '12px', display: 'block', marginTop: '4px'}}>
                Появится отдельный метод оплаты в боте/сайте/мини-аппе. Работает через Platega, но с другим paymentMethod.
              </small>
            </div>
          </div>
          <div style={{marginTop: '10px', padding: '10px', backgroundColor: 'var(--bg-secondary)', borderRadius: '4px'}}>
            <small style={{color: 'var(--text-secondary)', fontSize: '12px'}}>
              <strong>Важно:</strong> После настройки Platega необходимо указать URL вебхука в личном кабинете Platega: <br/>
              <code style={{wordBreak: 'break-all'}}>{typeof window !== 'undefined' ? window.location.origin : ''}/api/webhook/platega</code>
            </small>
          </div>
          
          {/* --- Mulenpay --- */}
          <h3 style={{marginTop: '30px'}}>Mulenpay</h3>
          <div className="form-row">
            <div className="form-group">
              <label>API Key</label>
              <input 
                type="text" 
                name="mulenpay_api_key"
                value={settings.mulenpay_api_key} 
                onChange={handleChange} 
                placeholder="API ключ из личного кабинета Mulenpay"
              />
              <small style={{color: 'var(--text-secondary)', fontSize: '12px'}}>
                API ключ для аутентификации запросов к Mulenpay API
              </small>
            </div>
            <div className="form-group">
              <label>Secret Key</label>
              <input 
                type="text" 
                name="mulenpay_secret_key"
                value={settings.mulenpay_secret_key} 
                onChange={handleChange} 
                placeholder="Secret ключ из личного кабинета Mulenpay"
              />
              <small style={{color: 'var(--text-secondary)', fontSize: '12px'}}>
                Secret ключ для аутентификации запросов к Mulenpay API
              </small>
            </div>
          </div>
          <div className="form-row">
            <div className="form-group">
              <label>Shop ID</label>
              <input 
                type="text" 
                name="mulenpay_shop_id"
                value={settings.mulenpay_shop_id} 
                onChange={handleChange} 
                placeholder="ID магазина из личного кабинета Mulenpay"
              />
              <small style={{color: 'var(--text-secondary)', fontSize: '12px'}}>
                Идентификатор магазина можно найти в личном кабинете Mulenpay
              </small>
            </div>
          </div>
          <div style={{marginTop: '10px', padding: '10px', backgroundColor: 'var(--bg-secondary)', borderRadius: '4px'}}>
            <small style={{color: 'var(--text-secondary)', fontSize: '12px'}}>
              <strong>Важно:</strong> После настройки Mulenpay необходимо указать URL вебхука в личном кабинете Mulenpay: <br/>
              <code style={{wordBreak: 'break-all'}}>{typeof window !== 'undefined' ? window.location.origin : ''}/api/webhook/mulenpay</code>
            </small>
          </div>
          
          {/* --- UrlPay --- */}
          <h3 style={{marginTop: '30px'}}>UrlPay</h3>
          <div className="form-row">
            <div className="form-group">
              <label>API Key</label>
              <input 
                type="text" 
                name="urlpay_api_key"
                value={settings.urlpay_api_key} 
                onChange={handleChange} 
                placeholder="API ключ из личного кабинета UrlPay"
              />
              <small style={{color: 'var(--text-secondary)', fontSize: '12px'}}>
                API ключ для аутентификации запросов к UrlPay API
              </small>
            </div>
            <div className="form-group">
              <label>Secret Key</label>
              <input 
                type="text" 
                name="urlpay_secret_key"
                value={settings.urlpay_secret_key} 
                onChange={handleChange} 
                placeholder="Secret ключ из личного кабинета UrlPay"
              />
              <small style={{color: 'var(--text-secondary)', fontSize: '12px'}}>
                Secret ключ для аутентификации запросов к UrlPay API
              </small>
            </div>
          </div>
          <div className="form-row">
            <div className="form-group">
              <label>Shop ID</label>
              <input 
                type="text" 
                name="urlpay_shop_id"
                value={settings.urlpay_shop_id} 
                onChange={handleChange} 
                placeholder="ID магазина из личного кабинета UrlPay"
              />
              <small style={{color: 'var(--text-secondary)', fontSize: '12px'}}>
                Идентификатор магазина можно найти в личном кабинете UrlPay
              </small>
            </div>
          </div>
          <div style={{marginTop: '10px', padding: '10px', backgroundColor: 'var(--bg-secondary)', borderRadius: '4px'}}>
            <small style={{color: 'var(--text-secondary)', fontSize: '12px'}}>
              <strong>Важно:</strong> После настройки UrlPay необходимо указать URL вебхука в личном кабинете UrlPay: <br/>
              <code style={{wordBreak: 'break-all'}}>{typeof window !== 'undefined' ? window.location.origin : ''}/api/webhook/urlpay</code>
            </small>
          </div>
          
          {/* --- BTCPayServer --- */}
          <h3 style={{marginTop: '30px'}}>BTCPayServer ₿</h3>
          <div className="form-row">
            <div className="form-group">
              <label>Server URL</label>
              <input 
                type="text" 
                name="btcpayserver_url"
                value={settings.btcpayserver_url} 
                onChange={handleChange} 
                placeholder="https://btcpay.example.com"
              />
              <small style={{color: 'var(--text-secondary)', fontSize: '12px'}}>
                URL вашего BTCPayServer сервера (без завершающего слеша)
              </small>
            </div>
            <div className="form-group">
              <label>API Key</label>
              <input 
                type="text" 
                name="btcpayserver_api_key"
                value={settings.btcpayserver_api_key} 
                onChange={handleChange} 
                placeholder="API ключ из BTCPayServer"
              />
              <small style={{color: 'var(--text-secondary)', fontSize: '12px'}}>
                API ключ с правами: btcpay.store.cancreateinvoice, btcpay.store.canviewinvoices
              </small>
            </div>
          </div>
          <div className="form-row">
            <div className="form-group">
              <label>Store ID</label>
              <input 
                type="text" 
                name="btcpayserver_store_id"
                value={settings.btcpayserver_store_id} 
                onChange={handleChange} 
                placeholder="Store ID из BTCPayServer"
              />
              <small style={{color: 'var(--text-secondary)', fontSize: '12px'}}>
                Идентификатор магазина (Store ID) можно найти в настройках Store в BTCPayServer
              </small>
            </div>
          </div>
          <div style={{marginTop: '10px', padding: '10px', backgroundColor: 'var(--bg-secondary)', borderRadius: '4px'}}>
            <small style={{color: 'var(--text-secondary)', fontSize: '12px'}}>
              <strong>Важно:</strong> После настройки BTCPayServer необходимо указать URL вебхука в настройках Store в BTCPayServer: <br/>
              <code style={{wordBreak: 'break-all'}}>{typeof window !== 'undefined' ? window.location.origin : ''}/api/webhook/btcpayserver</code><br/>
              Выберите события: <strong>InvoiceSettled</strong> (обязательно)
            </small>
          </div>
          
          {/* --- Tribute --- */}
          <h3 style={{marginTop: '30px'}}>Tribute</h3>
          <div className="form-row">
            <div className="form-group">
              <label>API Key</label>
              <input 
                type="text" 
                name="tribute_api_key"
                value={settings.tribute_api_key} 
                onChange={handleChange} 
                placeholder="API ключ из панели автора Tribute"
              />
              <small style={{color: 'var(--text-secondary)', fontSize: '12px'}}>
                API ключ можно получить в Панели Автора Tribute: Настройки → API Keys → Generate API Key
              </small>
            </div>
          </div>
          <div style={{marginTop: '10px', padding: '10px', backgroundColor: 'var(--bg-secondary)', borderRadius: '4px'}}>
            <small style={{color: 'var(--text-secondary)', fontSize: '12px'}}>
              <strong>Важно:</strong> Tribute поддерживает валюты RUB и EUR. UAH и USD будут автоматически конвертированы в RUB и EUR соответственно.<br/>
              После настройки Tribute можно указать URL вебхука в настройках магазина (если поддерживается): <br/>
              <code style={{wordBreak: 'break-all'}}>{typeof window !== 'undefined' ? window.location.origin : ''}/api/webhook/tribute</code>
            </small>
          </div>
          
          {/* --- Robokassa --- */}
          <h3 style={{marginTop: '30px'}}>Robokassa</h3>
          <div className="form-row">
            <div className="form-group">
              <label>Merchant Login (Логин магазина)</label>
              <input 
                type="text" 
                name="robokassa_merchant_login"
                value={settings.robokassa_merchant_login} 
                onChange={handleChange} 
                placeholder="Логин магазина из личного кабинета Robokassa"
              />
              <small style={{color: 'var(--text-secondary)', fontSize: '12px'}}>
                Логин магазина можно найти в личном кабинете Robokassa в разделе "Мои магазины"
              </small>
            </div>
            <div className="form-group">
              <label>Password #1 (Пароль #1)</label>
              <input 
                type="text" 
                name="robokassa_password1"
                value={settings.robokassa_password1} 
                onChange={handleChange} 
                placeholder="Пароль #1 для подписания запросов"
              />
              <small style={{color: 'var(--text-secondary)', fontSize: '12px'}}>
                Пароль #1 используется для подписания запросов на создание ссылок оплаты
              </small>
            </div>
          </div>
          <div className="form-row">
            <div className="form-group">
              <label>Password #2 (Пароль #2)</label>
              <input 
                type="text" 
                name="robokassa_password2"
                value={settings.robokassa_password2} 
                onChange={handleChange} 
                placeholder="Пароль #2 для проверки уведомлений"
              />
              <small style={{color: 'var(--text-secondary)', fontSize: '12px'}}>
                Пароль #2 используется для проверки подписи уведомлений (ResultURL)
              </small>
            </div>
          </div>
          <div style={{marginTop: '10px', padding: '10px', backgroundColor: 'var(--bg-secondary)', borderRadius: '4px'}}>
            <small style={{color: 'var(--text-secondary)', fontSize: '12px'}}>
              <strong>Важно:</strong> После настройки Robokassa необходимо указать ResultURL в настройках магазина в личном кабинете Robokassa: <br/>
              <code style={{wordBreak: 'break-all'}}>{typeof window !== 'undefined' ? window.location.origin : ''}/api/webhook/robokassa</code><br/>
              Robokassa поддерживает валюту RUB. Другие валюты будут обработаны как RUB.
            </small>
          </div>
          
          {/* --- Freekassa --- */}
          <h3 style={{marginTop: '30px'}}>Freekassa</h3>
          <div className="form-row">
            <div className="form-group">
              <label>Shop ID (ID магазина)</label>
              <input 
                type="text" 
                name="freekassa_shop_id"
                value={settings.freekassa_shop_id} 
                onChange={handleChange} 
                placeholder="ID магазина из личного кабинета Freekassa"
              />
              <small style={{color: 'var(--text-secondary)', fontSize: '12px'}}>
                ID магазина можно найти в личном кабинете Freekassa в разделе "Мои магазины"
              </small>
            </div>
            <div className="form-group">
              <label>Secret (Секретное слово)</label>
              <input 
                type="text" 
                name="freekassa_secret"
                value={settings.freekassa_secret} 
                onChange={handleChange} 
                placeholder="Секретное слово для подписания запросов"
              />
              <small style={{color: 'var(--text-secondary)', fontSize: '12px'}}>
                Секретное слово используется для формирования подписи в платежной форме
              </small>
            </div>
          </div>
          <div className="form-row">
            <div className="form-group">
              <label>Secret 2 (Секретное слово 2)</label>
              <input 
                type="text" 
                name="freekassa_secret2"
                value={settings.freekassa_secret2} 
                onChange={handleChange} 
                placeholder="Секретное слово 2 для проверки уведомлений"
              />
              <small style={{color: 'var(--text-secondary)', fontSize: '12px'}}>
                Секретное слово 2 используется для проверки подписи уведомлений (Result URL)
              </small>
            </div>
          </div>
          <div style={{marginTop: '10px', padding: '10px', backgroundColor: 'var(--bg-secondary)', borderRadius: '4px'}}>
            <small style={{color: 'var(--text-secondary)', fontSize: '12px'}}>
              <strong>Важно:</strong> После настройки Freekassa необходимо указать URL оповещения в настройках магазина в личном кабинете Freekassa: <br/>
              <code style={{wordBreak: 'break-all'}}>{typeof window !== 'undefined' ? window.location.origin : ''}/api/webhook/freekassa</code><br/>
              Freekassa поддерживает валюты: RUB, USD, EUR, UAH, KZT. Для подтверждения получения уведомления сервер должен вернуть ответ "YES".
            </small>
          </div>
          
          {/* --- Кнопка сохранения --- */}
          <div style={{display: 'flex', alignItems: 'center', gap: '20px', marginTop: '20px'}}>
            <button 
              type="submit" 
              className="btn" 
              style={{maxWidth: '200px'}}
              disabled={saveStatus === 'saving'}
            >
              {saveStatus === 'saving' ? 'Сохранение...' : 'Сохранить ключи'}
            </button>
            {saveStatus === 'success' && (
              <div className="message-success">Сохранено!</div>
            )}
          </div>
        </form>
      </section>
    </main>
  );
}

export default AdminPaymentsPage;